var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ins',{staticClass:"adsbygoogle",style:(_vm.adStyle),attrs:{"data-ad-client":_vm.adClient,"data-ad-slot":_vm.adSlot,"data-ad-format":_vm.adFormat}})
}
var staticRenderFns = []

export { render, staticRenderFns }